import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiJava,
} from "react-icons/di";
import {
  SiJavascript,
  SiTypescript,
  SiCplusplus,
  SiPython,
  SiKotlin,
  SiPhp,
  SiGnubash
} from "react-icons/si";

function ProgrammingLanguages() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <DiJava />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiKotlin />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiCplusplus />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPython />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiTypescript />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiJavascript />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPhp />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiGnubash />
      </Col>
    </Row>
  );
}

export default ProgrammingLanguages;
